import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import setStatementQuery from './set-statement-query'
import feedStore from '../../feed/feed-store'

export default async function toggleCreatedByMe(context: BareActionContext<StatementState, RootState>)
{
    const form = statementStore.state.statementSearchForm
    form.createdByFollowing = false
    form.createdByUser = false

    if (!feedStore.state.isCurrent) {
        form.jybedByUser = true
    }
  
    setStatementQuery(context)

    return
}
